/**
 * Sends markJobRequestUploadFailed to the backend using fetch with keepalive: true
 * so the request can complete even when the page is unloading (reload/close).
 * Use this in beforeunload/unload handlers when the user leaves during an upload.
 */

import { relayStore } from "../RelayEnvironment";
import { AUTH_TOKEN_KEY } from "./constants";

const MUTATION = `
mutation MarkJobRequestUploadFailedMutation($input: MarkJobRequestUploadFailedInput!) {
  markJobRequestUploadFailed(input: $input) {
    jobRequest {
      id
      uploadStatus
      status
    }
  }
}
`;

/**
 * Mark one or more job request uploads as failed via keepalive fetch.
 * Safe to call from beforeunload; requests may complete after the page unloads.
 * @param {string|number|Array<string|number>} jobRequestIds - Single id or array of ids
 */
// eslint-disable-next-line import/prefer-default-export
export default function markUploadFailedOnUnload(jobRequestIds) {
  const ids = Array.isArray(jobRequestIds) ? jobRequestIds : [jobRequestIds];
  const token = relayStore.get(AUTH_TOKEN_KEY);
  const url = process.env.REACT_APP_GRAPHQL_URL;
  if (!url || !token) return;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  ids.forEach((id) => {
    const variables = {
      input: { jobRequestId: String(id) },
    };
    try {
      fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({ query: MUTATION, variables }),
        keepalive: true,
      });
    } catch (_) {
      // Ignore; page may be unloading
    }
  });
}
